// extracted by mini-css-extract-plugin
module.exports = {"header":"kvuaD","logo":"UprRF","btn":"wR898","btn-xs":"SW4uS","btn-sm":"o6JM9","btn-md":"E34T8","btn-lg":"_2pU4b","block":"ExHBP","round":"SbqcM"};